import collapse from "@alpinejs/collapse";
import persist from "@alpinejs/persist";
import Alpine from "alpinejs";
import homepageState from "./app/homepage";
import asyncPersistWithTTL from "./lib/async_persist_ttl.js";
import feedbackStatus from "./lib/feedback_status";
import formSyncStatus from "./lib/form_sync_status";
import offlineModeState from "./lib/offline_mode_state";
import opportunisticForms from "./lib/opportunistic_forms";
import pdfViewer from "./lib/pdf_viewer";
import placeTask from "./lib/place_task";
import processingForms from "./lib/processing_forms";
import pwaRequirements from "./lib/pwa_requirements";
import userPreview from "./lib/user_preview";

Alpine.data("feedbackStatus", feedbackStatus);
Alpine.data("formsSync", formSyncStatus);
Alpine.data("homepageState", homepageState);
Alpine.data("offlineModeState", offlineModeState);
Alpine.data("opportunisticForms", opportunisticForms);
Alpine.data("pdfViewer", pdfViewer);
Alpine.data("placeTask", placeTask);
Alpine.data("processingForms", processingForms);
Alpine.data("pwaRequirements", pwaRequirements);
Alpine.data("userPreview", userPreview);

window.Alpine = Alpine;
Alpine.plugin(asyncPersistWithTTL);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.start();
